<div class="d-flex">

  <div class="justify-content-center mat-form-field-wrapper">
    <button mat-raised-button (click)="showDate = 'start'">Seleziona {{title}}</button>
  </div>

  <div class="justify-content-center pl-2">
    <mat-card [ngClass]="showDate==='start' ? 'd-block' : 'd-none'" class="calendario">
      <mat-card-title>Seleziona data inizio</mat-card-title>
      <mat-calendar (selectedChange)="setStartDate($event)"> </mat-calendar>
    </mat-card>

    <mat-card [ngClass]="showDate==='end' ? 'd-block' : 'd-none'" class="calendario">
      <mat-card-title>Seleziona data fine</mat-card-title>
      <mat-calendar (selectedChange)="setEndDate($event)" [minDate]="start"> </mat-calendar>
    </mat-card>

    <div *ngIf="start && end">
      <mat-form-field appearance="">
        <mat-label>Periodo selezionato</mat-label>
        <input matInput readonly type="text" value="dal {{start | date : 'shortDate'}} al {{end |  date : 'shortDate'}}">
      </mat-form-field>
    </div>
  </div>
</div>

